import { render } from "./ShoppingCart.vue?vue&type=template&id=36d7d0e0&scoped=true"
import script from "./ShoppingCart.vue?vue&type=script&lang=js"
export * from "./ShoppingCart.vue?vue&type=script&lang=js"

import "./ShoppingCart.vue?vue&type=style&index=0&id=36d7d0e0&scoped=true&lang=css"

import exportComponent from "/Users/songj/GitHubCodes/cart-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d7d0e0"]])

export default __exports__